import { transition } from './animations';
import { breakpoints, type DeviceMediaQueries, devices, makeMediaQueries } from './breakpoints';
import { type DesignTokens, designTokens } from './design-tokens';
import { colors, palette } from './palette';
import { radiuses } from './radiuses';
import { shadows } from './shadows';
import { space } from './spacing';
import type { ThemeWithoutTokens } from './theme.types';
import { typography } from './typography';
import { zIndices } from './z-indices';

export type { ThemeWithoutTokens } from './theme.types';

export type Theme = ThemeWithoutTokens & {
  designTokens: DesignTokens;
  deviceMediaQueries: DeviceMediaQueries;
};

export const themeWithoutDesignTokens: ThemeWithoutTokens = {
  breakpoints,
  colors,
  devices,
  palette,
  radiuses,
  shadows,
  space,
  transition,
  typography,
  zIndices,
};

type DeepWritable<T> = T extends Record<string, any> ? { -readonly [P in keyof T]: DeepWritable<T[P]> } : any;
type DeepPartial<T> = T extends Record<string, any> ? { [Key in keyof T]?: DeepPartial<T[Key]> } : T;

export type ThemeOverrides = DeepWritable<ThemeWithoutTokens> & { designTokens?: Partial<DeepWritable<DesignTokens>> };
export type PartialThemeOverrides = DeepPartial<ThemeOverrides>;

export const theme: Theme = {
  designTokens: designTokens(themeWithoutDesignTokens),
  deviceMediaQueries: makeMediaQueries(themeWithoutDesignTokens.devices),
  ...themeWithoutDesignTokens,
};
